import React, { useEffect, useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Card, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { captilizeString } from '../functionUtils';
import Label from '../type/Label';
import CustomIcon from './CustomIcon';
import { analyticsTrackEvent } from '../../../utils/analytics/analytics-utils';

const CoveredMembersTabPanel = () => {
  const dependentEnrollments = useSelector(state => state.dependentEnrollments);
  const selfEnrollmentsFromStore = useSelector(
    state => state?.enrollments?.enrollmentsDetails
  );
  const tenantResource = useSelector(state => state.tenant.tenanantResource);
  const tenantProducts = useSelector(state => state.tenant.tenantProducts);
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  // const coveredMembers = useSelector(
  //   state => state.coverages?.coveredMembers?.coveredMemberDetails
  // );
  const memberAccounts = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails
  );
  usePageTitle(
    tenantLayouts.BenefitsCoveredMembersMainLayout.CoveredMembersConfig
      .titleId +
      '|' +
      tenantLayouts.BenefitsCoveredMembersMainLayout.CoveredMembersConfig
        .subtitle
  );
  const [enrollmentsList, setEnrollmentsList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  
  useEffect(() => {
    if (memberAccounts?.self || memberAccounts?.dependents)
      memberAccounts?.self
        ? setMemberList([
            { ...memberAccounts.self },
            ...memberAccounts.dependents
          ])
        : setMemberList([null, ...memberAccounts.dependents]);
  }, [memberAccounts]);
  const getPlanDetails = subscriberId => {
    let enrollmentRecord = null;
    if (enrollmentsList.length) {
      enrollmentRecord = enrollmentsList.filter(
        data => data?.memberID === subscriberId
      )[0];
    }
    return enrollmentRecord;
  };
  useEffect(() => {
    dependentEnrollments.length
      ? setEnrollmentsList([selfEnrollmentsFromStore, ...dependentEnrollments])
      : setEnrollmentsList([selfEnrollmentsFromStore]);
  }, [dependentEnrollments, selfEnrollmentsFromStore]);

  const getEnrollmentDetails = async member => {
    const { subscriberId } = member;
    //add the missing numbers for the suitable handbooks
    const starMedicaidHandbook = tenantProducts.starMedicaidHandbookIds;
    const perinateNewBornHandbook = tenantProducts.perinateNewBornHandbookIds;
    const perinateMemberHandbook = tenantProducts.perinateMemberHandbookIds;
    const enrollmentRecord = getPlanDetails(subscriberId);
    if (!enrollmentRecord) {
    // no enrollment found for this member; nothing to open
      return;
    }
    if (starMedicaidHandbook.includes(enrollmentRecord.classPlanID)) {
      window.open(tenantResource.starMedicaidHandbook);
    } else if (perinateNewBornHandbook.includes(enrollmentRecord.classPlanID)) {
      //give the proper handbook pdf url
      window.open(tenantResource.perinateNewBornHandbook);
      //give the proper handbook pdf url
    } else if (perinateMemberHandbook.includes(enrollmentRecord.classPlanID)) {
      window.open(tenantResource.perinateMemberHandbook);
    } else {
      /** FIXME:: need to handle not found case. One idea is to disable download button when planId not found in the records. */
    }
  };
  const CoverMemberConfig =
    tenantLayouts.BenefitsCoveredMembersMainLayout.CoveredMembersConfig;
  return (
      <Card className="covered-member-tab">
        {memberList.length === 0 || !memberList[0]?.firstName ? <Typography variant='h6'>No covered members to display.</Typography> :
            (memberList?.map((member, index) => (
            <div key={index} id="covered-member-card">
              <Typography
              variant="body1"
                className="covered-member-name"
              >{`${captilizeString(member?.firstName)} ${captilizeString(
                member?.lastName
              )}`}</Typography>
              <div className='covered-member-details'>
                {/* <Typography
                  variant="body1"
                  className="covered-member-relationship"
                >{`${captilizeString(member?.relationship)}`}</Typography> */}
                <Typography variant="body1" className="covered-member-plan">
                  {getPlanDetails(member?.subscriberId)?.planDescription}
                </Typography>
              </div>
              <Button
                variant="outlined"
                color="secondary"
                onClick={e => {
                  e.preventDefault();
                  getEnrollmentDetails(member);
                  analyticsTrackEvent(
                    'benefits_coveredmembers_handbook_clicked',
                    {
                      eventCategory: 'Plan Benefits Pathing'
                    }
                  );
                }}
              >
                <CustomIcon iconName={CoverMemberConfig.buttonIcon} />
                <Label id={CoverMemberConfig.buttonId} />
              </Button>
            </div>
          ))
        )}
      </Card>
  );
};

export default CoveredMembersTabPanel;
